import { useMsal } from '@azure/msal-react';
import { AppData } from '@scts/app-data';
import { NotFound, FooterSg, HeaderSg } from '@scts-ui/component-library';
import { useConfigLoader } from '@scts/utilities';
import { useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import AppealParamManager from '../appeal-param-manager/appeal-param-manager';
import AppealsManager from '../appeals-manager/appeals-manager';
import Contact from '../contact/contact';
import AccessibilityComponent from '../accessibility/accessibility';

const HomeComponent = () => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [menu, setMenu] = useState(false);
  const [transitionStage, setTransistionStage] = useState('fadeIn');
  const { instance } = useMsal();
  // const [showState, setShowState] = useState(false);
  const { data } = useConfigLoader();
  const menuDisplayText = 'Change Password';

  useEffect(() => {
    if (location !== displayLocation) setTransistionStage('fadeOut');
  }, [location, displayLocation]);

  // update header with new dropdown item as this is loaded from config has to be a better way
  // to do this but the value changes each environment so best way would be to load ALL menu items from DB
  useEffect(() => {
    if (data?.configuration.auth.changePassword) {
      if (
        AppData.header.dropdownMenuItems.findIndex(
          (x) => x.displayText === menuDisplayText
        ) === -1
      ) {
        AppData.header.dropdownMenuItems.unshift({
          displayText: menuDisplayText,
          routeUri: data.configuration.auth.changePassword,
          isHref: true,
          isCallback: false,
        });
        setMenu(true);
      }
    }
  }, [data]);

  //header component (the child) will pass event up the chain to the parent
  const logoutFunction = (logUserOut: boolean) => {
    if (logUserOut) {
      const logoutRequest = {
        account: instance.getAllAccounts()[0],
        scopes: [data?.configuration.auth.scopes],
      };
      instance.logoutRedirect(logoutRequest);
    }
  };

  return (
    <>
      <div className="ds_skip-links">
        <ul className="ds_skip-links__list">
          <li className="ds_skip-links__item">
            <a
              className="ds_skip-links__link"
              href={location.pathname + '#main-content'}
              data-navigation="skip-link-1"
            >
              Skip to main content
            </a>
          </li>
        </ul>
      </div>
      <div className="d-flex flex-row">
        {menu && (
          <HeaderSg
            parentCallbackFunction={logoutFunction}
            headerText={AppData.header.headerText}
            headerMenuItems={AppData.header.menuItems}
            headerSpecialMenuItems={AppData.header.dropdownMenuItems}
            logoImageAddress={'assets/images/ssc-logo-black.png'}
            logoSmallImageAddress={'assets/images/scts-logo-sm.png'}
            imageAltText="Social Security Chamber First Tier Tribunal for Scotland"
          />
        )}
      </div>

      <main
        id="main-content"
        className="flex-shrink-0 col-12 col-lg-10 offset-lg-1 col-xxl-8 offset-xxl-2 p-2 ds_wrapper"
      >
        <div
          className={`${transitionStage}`}
          onAnimationEnd={() => {
            if (transitionStage === 'fadeOut') {
              setTransistionStage('fadeIn');
              setDisplayLocation(location);
            }
          }}
        >
          <Routes location={displayLocation}>
            <Route
              path="*"
              element={
                <NotFound
                  links={AppData.notFound.links}
                  padding={'1rem'}
                  margin={'0'}
                  paddingTop={'0'}
                />
              }
            />

            <Route path={'/'} element={<AppealsManager />} />
            <Route path={'appeal/:appealId'} element={<AppealParamManager />} />
            <Route
              path={'accessibility'}
              element={<AccessibilityComponent />}
            />
            <Route path={AppData.routes.appeals} element={<AppealsManager />} />
            <Route path={AppData.routes.support} element={<Contact />} />
          </Routes>
        </div>
      </main>

      <div className="footer mt-auto">
        <FooterSg
          links={AppData.footer.links}
          backgroundColour={AppData.footer.backgroundColour}
          colour={AppData.footer.colour}
          padding={AppData.footer.padding}
          paddingBottom={AppData.footer.paddingBottom}
          copyrightMessage="Social Security Chamber"
        />
      </div>
    </>
  );
};

export default HomeComponent;
